import {Factory} from './Factory'
import Menu from '../EditorComponents/SingleImage/Menu'

export class SingleImageFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('single-image'),
      slug: 'editor-single-image',
      "assets": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "background": {
        "phone": "color",
        "tablet": "color",
        "desktop": "color"
      },
      "customClasses": [],
      "constantClasses": {
        "phone": [],
        "tablet": [],
        "desktop": []
      },
      "containerClasses":{
        "phone": [],
        "tablet": [],
        "desktop":[]
      },
      "styles":{
        "phone": [],
        "tablet": [],
        "desktop":[]
      },
      "name":"SingleImage",
    }
  }

  properties() {
    return {
      content: [
        {key: 'source-content', component:'ContentSource'},
        {key:'text-content', component:'ContentText', text:'source link', property:'srcLink'},
        {key:'click-content', component:'ContentClickAction'},
        {key:'text-content', component:'ContentText', text:'external link', property:'link'},
      ],
      styles: [
        {key: 'text-alignment', component:'TextAlignmentProperty', class:'containerClasses', except: ['JUSTIFY']},
        {key: 'border', component:'BorderProperty'},
        {key: 'rounded', component:'RoundedProperty'},
        {key: 'shadow', component:'ShadowProperty'},
        {key: 'margin', component:'MarginProperty', class:'containerClasses'},
        {key: 'size', component:'ImageSizeProperty'}
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}